import { hasCompleteBillingAddress } from '../address/address'

import {
  ProfileCompletionField,
  SkillLevel,
  type ProfileDetailsModel,
  type UserProfile,
} from '../../types/user/userProfile'

export type SkillLevelCategory =
  'beginner' | 'intermediate' | 'advanced' | 'pro'

const SKILL_LEVEL_CATEGORIES: Record<SkillLevel, SkillLevelCategory> = {
  [SkillLevel.LEVEL_1]: 'beginner',
  [SkillLevel.LEVEL_2]: 'beginner',
  [SkillLevel.LEVEL_3]: 'intermediate',
  [SkillLevel.LEVEL_4]: 'intermediate',
  [SkillLevel.LEVEL_5]: 'advanced',
  [SkillLevel.LEVEL_6]: 'advanced',
  [SkillLevel.LEVEL_7_PLUS]: 'pro',
}

export const getSkillLevelCategory = (level: SkillLevel): SkillLevelCategory =>
  SKILL_LEVEL_CATEGORIES[level]

export const initials = (name: string): string =>
  name
    .split(' ')
    .map(x => x[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

export const displayName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  fallbackName: string
): string =>
  [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ') ||
  fallbackName

export const REQUIRED_PROFILE_DETAILS_FIELDS = [
  ProfileCompletionField.NICKNAME,
  ProfileCompletionField.FIRST_NAME,
  ProfileCompletionField.LAST_NAME,
] as const satisfies readonly (keyof ProfileDetailsModel)[]

const hasValue = (value: unknown): boolean =>
  value !== null &&
  value !== undefined &&
  (typeof value !== 'string' || value.trim().length > 0)

export const getMissingProfileFields = (
  profile: UserProfile
): ProfileCompletionField[] =>
  REQUIRED_PROFILE_DETAILS_FIELDS.filter(field => !hasValue(profile[field]))

export const hasCompletePersonalDetails = (
  profile?: UserProfile | null
): boolean => Boolean(profile && getMissingProfileFields(profile).length === 0)

export const hasAcceptedTerms = (profile?: UserProfile | null): boolean =>
  profile?.termsConsent === true

export const hasCompletePaymentProfile = (
  profile?: UserProfile | null
): boolean =>
  hasCompletePersonalDetails(profile) &&
  hasAcceptedTerms(profile) &&
  hasCompleteBillingAddress(profile?.address)
